export const DEBUG = false;

export const API_KEY_GOOGLE_SITEKEY = "6LfUqcEbAAAAAAPLbxl9N68er2YFlh4at3sHTek7";

//OAUTH
export const API_KEY_GOOGLE_CLIENT = "539217390833-t3n3es89lrmcjv7ap4gj6ujodhsg5kn1.apps.googleusercontent.com";
export const API_KEY_KAKAO_CLIENT = "c40c6341dbf38dde2b8bbe951ba61b5f";
export const API_KEY_NAVER_CLIENT = "CPIzBgSpcUliCP93GeNX";